import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setHasUserChangedLanguage', function setHasUserChangedLanguage(value) {
    getRegionalOptions().hasUserChangedLanguage = value;
});
//# sourceMappingURL=setHasUserChangedLanguage.js.map